import React,{useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/research-breadcrumb.webp';
import Cta from "../Components/Cta";
import Gallery from "../Components/Gallery";
import { qualitySteps, researchGalleryData } from "../Data";
import Certificates from "../Components/Certificates";
import ContactSection from "../Components/ContactSection";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import heroImg from '../Images/research-intro.webp'

import "swiper/css";
import "swiper/css/navigation";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import aboutPageSchema from "../Schema/AboutPageSchema";


const Research=()=>{
    useEffect(() => {
                document.title =
                  "Research & Quality Control Excellence | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "See how Iris Impulse India Pvt. Ltd. ensures top-quality minerals through rigorous research, testing, and quality control practices. Enquire today for products!"
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/about-us/research-quality");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Research & Quality Control Excellence | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "See how Iris Impulse India Pvt. Ltd. ensures top-quality minerals through rigorous research, testing, and quality control practices. Enquire today for products!"
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/about-us/research-quality");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/research-quality.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Research & Quality Control Excellence | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "See how Iris Impulse India Pvt. Ltd. ensures top-quality minerals through rigorous research, testing, and quality control practices. Enquire today for products!"
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/research-quality.webp"
                );
              }
              }, []);

     const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [activeSlide, setActiveSlide] = useState(1);

  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" }
  }
};

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

   const { ref: statsRef, inView: statsInView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });


const organizationData = organizationSchema();
const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "About Us",
      url: "https://irisimpulse.com/about-us"
    },
    {
      name: "Research & Quality Control",
    },
  ],
});
const aboutPageData = aboutPageSchema({
  url: "https://irisimpulse.com/about-us/research-quality",
  title: "Research & Quality Control Excellence | Iris Impulse India Pvt. Ltd.",
  description:
    "See how Iris Impulse India Pvt. Ltd. ensures top-quality minerals through rigorous research, testing, and quality control practices. Enquire today for products!",
  image: "https://irisimpulse.com/Images/research-quality.webp",
});

    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={aboutPageData} />

          <BreadCrumb
  title="Research & Quality Control" 
  bgImage={bgImg} 
/>

      {/**R&D FACILITES SECTION */}
      <section className="video-section container research-intro team-intro-section">
  

  <motion.div
    className="video-wrapper"
    variants={fadeLeft}
    initial="hidden"
    whileInView="visible"
   iewport={{ once: true, margin: "-50px" }}
  >
    <img src={heroImg} alt="R & D Facilities and Quality Control | Iris Impulse India Pvt. Ltd." />
  </motion.div>


  <motion.div
    className="mining-card"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <div className="mining-card-inner">

    <motion.h2 className="section-heading" variants={fadeUp}>
R & D Facilities and Quality Control
    </motion.h2>

    <motion.p className="section-text" variants={fadeUp}>
     At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, Gandhidham, Kutch, Gujarat, India, research and quality are the cornerstones of our operations. Our dedicated R&D facilities focus on continuous innovation, product improvement, and process optimization to meet the evolving needs of global industries. Every batch of minerals undergoes multi-stage sampling, testing, and analysis using advanced equipment to ensure international standards of purity, consistency, and performance. With a team of skilled professionals and a culture of innovation, we not only deliver high-quality minerals but also develop customized solutions that add value for our clients. By combining scientific research with strict quality control, <b className="bold">Iris Impulse India Pvt. Ltd.</b> ensures excellence from mine to market.
    </motion.p>

      <motion.h2
                className="section-heading"
                variants={fadeUp}
              >
                EXPERIENCE THAT BUILDS TRUST
              </motion.h2>
    <motion.p
                className="section-text"
                variants={fadeUp}
              >
                With decades of industry experience, we have proudly served clients
                across the globe and successfully delivered projects for businesses
                in multiple industries. Our commitment to quality, innovation, and
                dependable execution helps organizations grow, scale, and achieve
                long-term success.
              </motion.p>

    <motion.div
            className="who-stats"
            ref={statsRef}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >

            <motion.div
              className="who-stat"
              variants={fadeUp}
            >
              <h3>
                {statsInView && <CountUp end={25} duration={3} />}+
              </h3>

              <p className="section-text">
                Years Of Experience
              </p>
            </motion.div>

            <motion.div
              className="who-stat"
              variants={fadeUp}
            >
              <h3>
                {statsInView && <CountUp end={500} duration={3} />}+
              </h3>

              <p className="section-text">
                Global  Clients
              </p>
            </motion.div>

            <motion.div
              className="who-stat"
              variants={fadeUp}
            >
              <h3>
                {statsInView && <CountUp end={40} duration={3} />}+
              </h3>

              <p className="section-text">
                Products for Various Application
              </p>
            </motion.div>

          </motion.div>
</div>
  </motion.div>
</section>

      {/**OUR QUALITY POLICY SECTION */}
       <section className="quality-points-section container process-flow-section">

  {/* TOP */}

  <motion.h2
    className="section-heading"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    Our Quality Policy
  </motion.h2>

  <motion.p
    className="section-text"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >
    “We, at <strong className="bold">Iris</strong> are committed to Manufacture, Sale & Export of Various
    Grades of Bentonite & Other Minerals conforming to Customer
    Requirements & Meeting Product Specifications for Highest Customer
    Satisfaction in time, every time abiding regulations considering the
    external & internal issues and needs & expectations of interested
    parties.We are also committed for continual improvement in Quality
    Management System processes and overall improvement in our QMS
    effectiveness with the help of dedicated & motivated personnel and by
    review of the Quality Management System.”
  </motion.p>

  {/* SLIDER */}

  <motion.div
    className="quality-points-slider-wrapper"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.1 }}
  >

    <Swiper
      modules={[Navigation]}
      slidesPerView={1}
      speed={900}
      loop={true}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      onBeforeInit={(swiper) => {

        swiper.params.navigation.prevEl =
          prevRef.current;

        swiper.params.navigation.nextEl =
          nextRef.current;
      }}
     onSwiper={(swiper) => {

  setTimeout(() => {

    if (!swiper || !swiper.params || !swiper.navigation) return;

    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;

    swiper.navigation.destroy();
    swiper.navigation.init();
    swiper.navigation.update();

  });

}}
      onSlideChange={(swiper) => {
        setActiveSlide(swiper.realIndex + 1);
      }}
      className="process-flow-slider"
    >

      {qualitySteps.map((item) => (

        <SwiperSlide key={item.id}>

          <div className="process-flow-slide">

            {/* IMAGE */}

            <div className="process-flow-image-wrapper">

              <motion.img
                src={item.image}
                alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                className="quality-points-image"
                whileHover={{
                  scale: 1.2,
                }}
                transition={{
                  duration: 0.5,
                }}
              />

           

            {/* CARD */}

                     <motion.div
                           className="process-flow-card"
                           initial={{ opacity: 0, y: 30 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           viewport={{ once: true }}
                           transition={{
                             duration: 0.7,
                             delay: 0.2,
                           }}
                         >
                           <div className="process-flow-row">
           
                           <motion.span
                             className="process-flow-number"
                             whileHover={{
                               scale: 1.08,
                             }}
                           >
                             {item.id}
                           </motion.span>
           
                           <h3 className="card-heading">
                             {item.title}
                           </h3>
                           </div>
           
                           <p className="section-text">
                             {item.desc}
                           </p>
           
                         </motion.div>
                          </div>
          </div>

        </SwiperSlide>
      ))}

    </Swiper>

    {/* BOTTOM NAVIGATION */}

    <motion.div
      className="quality-points-bottom-nav"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.3 }}
    >

      <motion.div
        ref={prevRef}
        className="quality-points-arrow"
        whileHover={{
          scale: 1.1,
        }}
        whileTap={{
          scale: 0.92,
        }}
      >
        &#10094;
      </motion.div>

      <div className="quality-points-count">

        <span>
          {String(activeSlide).padStart(2, "0")}
        </span>

        <span className="quality-points-divider">
          /
        </span>

        <span>
          {String(qualitySteps.length).padStart(2, "0")}
        </span>

      </div>

      <motion.div
        ref={nextRef}
        className="quality-points-arrow"
        whileHover={{
          scale: 1.1,
        }}
        whileTap={{
          scale: 0.92,
        }}
      >
        &#10095;
      </motion.div>

    </motion.div>

  </motion.div>

</section>

          {/**R & D FACILITIES SECTION */}
    <Gallery
  heading="R & D Facilities"
  description="With In-house Lab facility and competent staff enable Iris Impulse for continuous Product Enhancement, New Product Developments, Cost effectiveness studies etc."
  images={researchGalleryData}
/>

           
    {/**CTA SECTION */}
    <Cta />

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />
        </>
    )
}
export default Research;